import { range } from "lodash";

export function copy(input: string | HTMLInputElement | HTMLTextAreaElement): void {
  if (typeof input === 'string') {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(input);
    }
  } else {
    input.select();
    if (navigator.clipboard) {
      navigator.clipboard.writeText(input.value);
    } else {
      document.execCommand('copy');
    }
  }
}

export function permute<T>(input: T[]): T[][] {
  //quickperm countdown algorithm
  const results: T[][] = [[...input]];
  const n = input.length;
  const p = range(0, n + 1);
  for (let i = 1; i < n;) {
    p[i]--;
    const j = i % 2 ? p[i] : 0;
    input = [...input];
    [input[j], input[i]] = [input[i], input[j]];
    results.push(input);
    for (i = 1; !p[i]; i++) p[i] = i;
  }
  return results;
}
